// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__W0K9f","l13":"Loader_l13__6AMXG"};